<template>

<div>
  <PageTitle :route="$route">
    <template slot="action-button">
      <ActionButton
        icon="fa-plus"
        v-on:click="onClickButton"
      />
    </template>
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <MovementTypeList />
    </div>
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import MovementTypeList from '@/components/settings/stock-registers/movementType/MovementTypeList'
import ActionButton from '@/components/button/ActionButton'

export default {
  name: 'MovementType',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    MovementTypeList
  },
  methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addmovementtype' })
    }
  }
}
</script>